// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"5ffa6f21cb59cc8ad980","678":"c318d723f76d4924b3fb"}[chunkId] + ".js";
};